<que-preview [viewAnswer]="true"></que-preview>
